import $ from 'jquery';
import GroupedContent from 'grouped-content';

export default class RTE {
  constructor() {
    this.groupedContents = [];
    this.$rteContainers = $('.rte');

    this._init();

    window.addEventListener('shopify:section:load', () => {
      this._update();
    });
  }

  _init() {
    this.$rteContainers.each((index, rteContainer) => {
      this.groupedContents.push(new GroupedContent(rteContainer, { layout: 'accordion', intelliparse: false }));
    });
  }

  _update() {

    this.$rteContainers = $('.rte')
      .not((index, element) => $(element).has('.grouped-content').length > 0);

    this._init();
  }
}
